import {IEntity} from "../../../typescript-plugin/entities/IEntity";
import {LeasingType} from "./LeasingType";
import {Leasing} from "./Leasing";
import {Calendar} from "./calendar/Calendar";
import {Key} from "../../../typescript-plugin/entities/Key";
import {Unavailability} from "./unaivailability/Unavailability";
import {IdKey} from "../../../typescript-plugin/entities/IdKey";

export class Van implements IEntity{

    public id:string;
    public type:LeasingType;
    public enabled:boolean;
    public plate:string;

    public leasing:Leasing;
    public calendar:Calendar;
    public unavailability:Unavailability;

    public Key(): Key {
        return new IdKey(this.id);
    }

    public Serialize(): {} {
        return {
            id: this.id,
            type: this.type,
            plate: this.plate,
            leasing: this.leasing != undefined ? this.leasing.Serialize() : undefined,
            calendar: this.calendar != undefined ? this.calendar.Serialize() : undefined,
            unavailability: this.unavailability != undefined ? this.unavailability.Serialize() : undefined,
            enabled: this.enabled
        }
    }

    public Deserialize(data: {}): void {
        this.id = data['id'];
        this.enabled = data['enabled'];
        this.plate =  data['plate'];
        this.type = data['type'];

        if(data['leasing'] != undefined){
            this.leasing = new Leasing();
            this.leasing.Deserialize(data['leasing']);
        }

        if(data['calendar'] != undefined){
            this.calendar = new Calendar();
            this.calendar.Deserialize(data['calendar']);
        }

        if(data['unavailability'] != undefined){
            this.unavailability = new Unavailability();
            this.unavailability.Deserialize(data['unavailability']);
        }
    }

    public ToPersistable(): {} {
        return {
            id: this.id,
            type: this.type,
            plate: this.plate,
            enabled: this.enabled
        };
    }

    public ToEntity(data: {}): void {
        this.id = data['id'];
        this.type = data['type'];
        this.enabled = data['enabled'];
        this.plate =  data['plate'];
    }

    public AsFake():Van{
        this.id = "VanId";
        this.enabled = true;
        this.plate = "ABC-312";
        this.leasing = new Leasing().AsFake();
        this.type = this.leasing.type;
        this.calendar = new Calendar().AsFake();
        this.unavailability = new Unavailability().AsFake();
        return this;
    }

}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/Van.ts